export const API = {
  /**
   * 系统模块
   */
  noCheckSmsSendSmsCode: 'server-usercenter/nocheck/sms/sendSmsCode', // 发送验证码
  /**
   * 企业模块
   */
  selectCompanyPage: 'server-usercenter/test/query', // 企业列表，分页
  /**
   * 用户模块
   */
  loginNoCheckDoLogin: 'server-usercenter/login/nocheck/doLogin', // 登录
  registerNoCheckDoRegister: 'server-usercenter/register/nocheck/doRegister', // 注册
  wxLoginCheck: 'server-usercenter/wechat/nocheck/getUserInfoByCode',
  noCheckCheckPhoneHave: 'server-usercenter/register/nocheck/checkPhoneHave',// 校验注册手机号码是否存在
  checkLoginPhoneHave: 'server-usercenter/login/nocheck/checkLoginPhoneHave',// 校验登录手机号码是否存在
  loginDoLogout: 'server-usercenter/login/doLogout', // 退出登录
   /**
   * 工厂主页
   */
  selCompanyReleaseInfoFormEs: 'server-preweb/companyInfoEs/selCompanyReleaseInfoFormEs', // 初始化主页发布的主信息
  selReleaseProdCasePageFormEs: 'server-preweb/companyInfoEs/selReleaseProdCasePageFormEs',//分页查询案例信息
  selTwoAndThreeProdType: 'server-preweb/companyInfoEs/selTwoAndThreeProdType',//根据行业分类  查询产品 二级分类 、 三级分类
  selProdInfoPageFormEs: 'server-preweb/companyInfoEs/selProdInfoPageFormEs',//分页查询 标准件产品
  selCompanyInfoPageFormEs:  'server-preweb/companyInfoEs/selCompanyInfoPageFormEs',//分页查询 企业信息list  首页
  selCompanyForHomeFormDb:  'server-preweb/companyInfoEs/selCompanyForHomeFormDb',//分页查询 企业信息list  首页   直接查数据库，9宫格
  selReleaseProdCasePageForHome:  'server-preweb/companyInfoEs/selReleaseProdCasePageForHome',//分页查询 案例信息list  首页
  selUserDemandPageForHome: 'server-preweb/companyInfoEs/selUserDemandPageForHome',//分页查询 客户需求信息list  首页
  selByUserIdAndCompanyId: 'server-preweb/ccProjectInfo/selByUserIdAndCompanyId',//根据userId和companyId查询关注企业信息
  saveOrDelUcFollowCompany: 'server-preweb/ccProjectInfo/saveOrDelUcFollowCompany',//保存关注或取消关注企业数据
  fnUpdateHitsNum: 'server-preweb/ccProjectInfo/fnUpdateHitsNum',//更新点击数量
  selProdTypeFormDb: 'server-preweb/companyInfoEs/selProdTypeFormDb',//查询所有的产品分类含数据库中的
  selCompanyTypeFormDb: 'server-preweb/companyInfoEs/selCompanyTypeFormDb',//查询所有的企业分类含数据库中的,
  selReleaseBoutiquePhotoPage: 'server-preweb/companyInfoEs/selReleaseBoutiquePhotoPage', // 根据精品分类id过滤精品分类数据
  selGridPageForHome: 'server-preweb/companyInfoEs/selGridPageForHome',//网格信息查询
  queryProdTypeTreeSelect: 'server-preweb/companyInfoEs/queryProdTypeTreeSelect', // 获取产品分类 树结构返回
  selSysKfData:  'server-preweb/sysDictItem/selSysKfData', // 获取产品分类 树结构返回
  /**
   * 机构主页
   */
  selSocietyInfoById: 'server-preweb/companyInfoEs/selSocietyInfoById',//根据id查询机构发布主信息
  selSocietyCompanyPageFormEsForHome:'server-preweb/companyInfoEs/selSocietyCompanyPageFormEsForHome',//根据条件 分页查询 机构内公司信息list  机构首页
  selSocietyCompanyPageFormEs:'server-preweb/companyInfoEs/selSocietyCompanyPageFormEs',//根据条件 分页查询 机构内公司信息list  机构首页

  selSocietyProdCasePageForHome:'server-preweb/companyInfoEs/selSocietyProdCasePageForHome',//根据条件 分页查询 机构内公司发布的案例信息list   机构首页用
  selSocietyProdCasePage:'server-preweb/companyInfoEs/selSocietyProdCasePage',//根据条件 分页查询 机构内公司发布的案例信息list   搜索页用
  selUserDemandById: 'server-preweb/companyInfoEs/selUserDemandById',
  /**
   * 案例详情页
   */
  getProjectInfoById: 'server-preweb/ccProjectInfo/getProjectInfoById',//根据id初始化案例详情
  queryByUserIdAndCompanyId: 'server-usercenter/ccCustInfo/queryByUserIdAndCompanyId',//根据当前登录的用户id 和 companyId 查询当前客户是否已经生成了改企业的客户信息
  /**
   * 全局搜索页
   */
  selAllProdCaseType:'server-preweb/companyInfoEs/selAllProdCaseType',//查询所有案例分类
  selAllCompanyType:'server-preweb/companyInfoEs/selAllCompanyType',//查询所有案例分类
  /**
   * 客户需求列表
   */
  selAllUserDemandType: 'server-preweb/companyInfoEs/selAllUserDemandType',//查询所有需求分类

  /**
  * 方案和AI报价
  */
  loadAiSchemeBySaasProjectId: 'server-usercenter/aiScheme/loadAiSchemeBySaasProjectId',
  designPrice: 'server-usercenter/CdrDesignPrice/designPrice',
  /**
  * 保存报价单
  */
  saveUcQuotationAi: 'server-usercenter/ucQuotation/saveUcQuotationAi',
  /**
  * 导出报价单到excel
  */
  exportUcQuotationExcelAi: 'server-usercenter/ucQuotation/exportUcQuotationExcelAi',
  /**
  * 企业统计信息修改
  */
  updateReleaseReoprtByCompanyId: 'server-usercenter/ccReleaseReport/updateReleaseReoprtByCompanyId',
  /**
  * 查询制作类型
  */
  querySysProdType: 'server-usercenter/sysProdType/querySysProdType',
  /**
  *
  */
   selCcProjectInfoByCompanyId: 'server-usercenter/ccProjectInfo/selCcProjectInfoByCompanyId',
   /**
  *
  */
    saveCcCompanySupplyDemand: 'server-usercenter/ccCompanySupplyDemand/saveCcCompanySupplyDemand',
    selCompanyListByUserIdAndSocietyId: 'server-usercenter/ccCompany/selCompanyListByUserIdAndSocietyId',
  /**
  * 查询制作类型
  */
  uploadFile: 'server-usercenter/ccFileInfo/uploadFile',
  /**
  * 查询制作类型
  */
  downloadFile: 'server-usercenter/ccFileInfo/download/file',
  /**
  * 发布需求 保存方法
  */
  saveUcDemand: 'server-usercenter/ucDemand/saveUcDemand',
  /**
  * 通过需求id，查询需求详情
  */
  queryDemandInfoById: 'server-usercenter/ucDemand/queryDemandInfoById',
  /**
   * 文章资讯
   */
   selAllSocietyArticleNewsType: 'server-preweb/companyInfoEs/selAllSocietyArticleNewsType', // 查询所有文章资讯分类list
   selSocietyArticleNewsPage: 'server-preweb/companyInfoEs/selSocietyArticleNewsPage', // 机构 根据条件分页查询文章资讯list
   selSocietyArticleNewsById: 'server-preweb/companyInfoEs/selSocietyArticleNewsById', // 机构 根据文章资讯id查询资讯详情

  /**入驻、开通相关**/
  /**查询平台应用列表**/
  queryApplications: 'server-usercenter/sysApplicationInfo/querySysApplicationInfoAll',
  /**查询企业烈性**/
  querySysDictItemByDictId: 'server-usercenter/sysDictItem/querySysDictItemByDictId',
  /**保存入驻**/
  saveCcCompanyInfo: 'server-usercenter/ccCompany/saveCcCompanyInfo',
  /**保存入驻  快速入驻   内部员工使用**/
  saveCcCompanyInfoNb: 'server-usercenter/ccCompany/saveCcCompanyInfoNb',
  /**扫码后选择企业绑定*/
  companyBindSaas: 'server-usercenter/ccCompany/companyBindSaas',
  /**查询用户绑定的企业*/
  queryUserHaveCcCompany: 'server-usercenter/ccCompany/queryUserHaveCcCompany',
  /**home页和服务商列表页查询*/
  selSupplyDemandShowPage: 'server-preweb/companyInfoEs/selSupplyDemandShowPage',
  selSupplyDemandById: 'server-preweb/companyInfoEs/selSupplyDemandById', // home页和服务商点击详情
  selAllSupplyDemandType: 'server-preweb/companyInfoEs/selAllSupplyDemandType', // home页和服务商点击详情
  companyBindSaas: 'server-usercenter/ccCompany/companyBindSaas',
  // 平台应用信息查询
  queryAllSysApplicationInfo: 'server-preweb/sysAppInfo/queryAllSysApplicationInfo',
  /**免费试用接口*/
  freeTrySaasSystem: 'server-usercenter/ccCompany/freeTrySaasSystem',
  /**
  * 通过APPID查询行业分类
  */
  querySysDictItemByDictIdAndAppId: 'server-usercenter/sysDictItem/querySysDictItemByDictIdAndAppId',
  /**
  * 校验用户是否已有绑定的SAAS应用
  */
  checkUserBindFactory: 'server-usercenter/SaasUserBind/checkUserBindFactory'
}



// WEBPACK FOOTER //
// ./src/util/api.js